var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pizzeria-lang"},[_c('a',{staticClass:"button-lang button-lang-ru",class:{'selected': _vm.lang === 'ru'},attrs:{"href":"?lang=ru"}}),_c('a',{staticClass:"button-lang button-lang-en",class:{'selected': _vm.lang === 'en'},attrs:{"href":"?lang=en"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }